

export default function analytics  (event, data)  {
    console.log('gtag main function executed', event, data)
    
    const importedAnalytics = import('~/utils/analytics/analytics.helper.js')
    importedAnalytics.then((analyticsHelper) => {
        console.log('analytics imported:', analyticsHelper)

        // // Check if analytics is a function
        // if (typeof analytics === 'function') {
        //     console.log('Calling analytics function with event:', event, 'and data:', data);
            analyticsHelper.trigerGtagUtils(event, data);
        // }

    }).catch(error => {
        console.error('Error importing analytics:', error);
        throw error;
    });
}

